module.exports = __webpack_public_path__ + "static/img/PB115603.8522bb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/PB115603.jpg
// module id = BOMe
// module chunks = 0